export default __webpack_public_path__ + "static/media/stone_everflame_seed.cb78f168.png";